import { ReactElement } from 'react';
import Image from 'next/image';
import { Box } from '@chakra-ui/react';

import image from '@public/man-with-glass.png';

import { BoxImageProps } from '../types';

// this is the Largest Contentful Paint element in /criar-perfil-gratis. So property priority is set to true
const ManWithGlass = ({ layout, ...props }: BoxImageProps): ReactElement => (
  <Box {...props}>
    <Image
      src={image}
      layout={layout}
      priority
      alt='Homem feliz e sorridente segurando o oculos'
    />
  </Box>
);

export default ManWithGlass;
